import React from "react";
import {useFormik} from "formik";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Radio from '@mui/material/Radio';
import LoadingButton from "@mui/lab/LoadingButton";


const RadioGroupForm = (props) => {
    const {attribute, label, value, defaultValue=null, options, validationSchema, onClose, onSubmit, isLoading} = props

    const formik = useFormik({
        initialValues: {[attribute]: value === null || value === undefined ? defaultValue : value},
        validationSchema: validationSchema,
        validateOnMount: true,
        onSubmit: onSubmit,
    });

    return <Dialog onClose={onClose} open={true} fullWidth>
        <DialogTitle>Aggiorna {label.toLowerCase()}</DialogTitle>
        <DialogContent>
            <FormControl component="fieldset">
                <RadioGroup
                    aria-label={label}
                    name={attribute}
                    value={formik.values[attribute]}
                    onChange={formik.handleChange}
                >
                    {
                        options.map(({label, value}, i) => (
                            <FormControlLabel key={i} label={label} value={value} control={<Radio/>}/>
                        ))
                    }
                </RadioGroup>
            </FormControl>
        </DialogContent>
        <DialogActions sx={{py: 2, px: 3}}>
            <Button color={"primary"}
                    variant={"text"}
                    onClick={onClose}>
                Cancella
            </Button>
            <LoadingButton onClick={() => formik.handleSubmit()}
                           loading={!!isLoading}
                           variant="contained">
                Salva
            </LoadingButton>
        </DialogActions>
    </Dialog>
}

RadioGroupForm.propTypes = {
    attribute: PropTypes.string.isRequired,  // Name of the attribute (it will be passed in an object when submit is called)
    label: PropTypes.string.isRequired,  // Label of the attribute shown
    value: PropTypes.any,  // Initial value of the attribute
    defaultValue: PropTypes.object,  // Default value of the value
    validationSchema: PropTypes.object,  // Validation schema for the attribute
    onClose: PropTypes.func.isRequired,  // Function called when closing the form
    onSubmit: PropTypes.func.isRequired,  // Function called when submitting the form
    options: PropTypes.array.isRequired,  // Array of option object each one with a label and a value keys
    isLoading: PropTypes.bool,
};

export default RadioGroupForm;